import { Button, Col, Card, Row, Icon, Text } from 'mymoria-ui/components';
import { mq, styled, css } from 'mymoria-ui/utils';
import React from 'react';
import { form } from 'data';

const { intro } = form;

const FlexCol = styled(Col)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
`;

const StyledFormCard = styled(Card)(
  ({ theme: { colors } }) => css`
    background-color: ${colors.white};
    background-position: top 0px right -2px;
    background-size: 308px 168px;
    background-image: url('/img/background.svg');
    background-repeat: no-repeat;

    ${mq({
      minHeight: ['auto', '450px', '450px', '480px'],
    })};
  `,
);

const ButtonCol = styled(Col)`
  display: flex !important;
  align-items: center;
  margin: 2rem 0;

  button {
    ${mq({
      width: ['100%', 'auto'],
    })};
  }

  ${mq({
    flexWrap: ['wrap', 'nowrap'],
    flexDirection: ['column', 'row'],
  })};
`;

const EstimatedTime = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  svg {
    margin-right: 0.5rem;
  }
`;

const Intro = () => (
  <StyledFormCard>
    <Row flexDirection="column" alignItems="center">
      <FlexCol width={1}>
        <Text mb="1rem">{intro.description}</Text>
      </FlexCol>
      <ButtonCol width={1}>
        <Button>{intro.button}</Button>
      </ButtonCol>
      <EstimatedTime>
        <Icon.Duration />
        <Text>{intro.time}</Text>
      </EstimatedTime>
    </Row>
  </StyledFormCard>
);

export default Intro;
